module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"match":"Match score - {0}"}}')
  delete Component.options._Ctor
}
